var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Popper, styled, Tooltip, tooltipClasses } from '@mui/material';
import { HelixPalette, HelixStyles } from '../../helix';
/**
 * Standard tooltip styled component.
 */
export const StandardTooltip = styled((_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return _jsx(Tooltip, Object.assign({}, props, { classes: { popper: className }, arrow: true }));
})(() => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: HelixPalette.neutral90,
        fontSize: '0.5rem',
    },
    [`& .${tooltipClasses.tooltip}`]: Object.assign(Object.assign({}, HelixStyles.style_07), { backgroundColor: HelixPalette.neutral90, borderRadius: '0.4 rem', color: HelixPalette.white, maxWidth: 274, padding: '0.25rem 0.5rem', whiteSpace: 'pre-line' }),
}));
/**
 * Popper component styled for contextual tooltip.
 */
export const ContextualTooltip = styled(Popper)(() => ({
    zIndex: 1,
    '&[data-popper-placement*="bottom"] .arrow': {
        top: '-4px',
    },
    '&[data-popper-placement*="top"] .arrow': {
        bottom: '-4px',
    },
    '&[data-popper-placement*="right"] .arrow': {
        left: '-4px',
    },
    '&[data-popper-placement*="left"] .arrow': {
        right: '-4px',
    },
    '.arrow, .arrow::before': {
        position: 'absolute',
        width: '0.5rem',
        height: '0.5rem',
    },
    '.arrow': {
        background: 'none',
    },
    '.arrow::before': {
        background: `${HelixPalette.neutral90}`,
        content: '""',
        transform: 'rotate(45deg)',
    },
}));
